import React from 'react'

import EtcPage from 'Components/EtcPage/EtcPage'

export default function NotFound() {
  return <EtcPage content="해당 페이지를 찾을 수 없습니다" />
}
